<template>
  <span
    class="svg-icon"
    :style="{
      display: block ? 'block' : 'inline-block',
      width: size,
      height: height,
      verticalAlign: 'middle',
      shapeRendering: 'inherit',
      transform: 'translate3d(0,0, 0)'
    }"
    :aria-hidden="isDecorativeOnly"
    v-html="iconRef" />
</template>

<script setup lang="ts">
import { computed, ref, watchEffect } from 'vue';

const props = defineProps({
  icon: { type: String, default: '' },
  block: { type: Boolean, default: true },
  isDecorativeOnly: { type: Boolean, default: false },
  color: { type: String, default: 'black' },
  iconSize: { type: String, default: 'md' },
  height: { type: String, default: '100%' }
});

const iconRef = ref('');
watchEffect(async () => {
  try {
    const iconsImport = import.meta.glob('../../assets/icons/**/**.svg', {
      query: '?raw',
      import: 'default',
      eager: false
    });
    const rawIcon = (await iconsImport[
      `../../assets/icons/${props.icon}.svg`
    ]()) as string;
    const iconWithColor = addFillColorToSvg(rawIcon, props.color || 'black');

    iconRef.value = iconWithColor;
  } catch {
    // eslint-disable-next-line no-console
    console.error(
      `[nuxt-icons] Icon '${props.icon}' doesn't exist in 'assets/icons'`
    );
  }
});

const size = computed(() => {
  if (props.iconSize === 'sm') {
    return '24px';
  } else if (props.iconSize === 'md') {
    return '32px';
  } else if (props.iconSize === 'xs') {
    return '20px';
  } else if (props.iconSize === 'lg') {
    return '36px';
  } else if (props.iconSize === 'xl') {
    return '150px';
  } else {
    return 'inherit';
  }
});

function addFillColorToSvg(svgContent: string, color: string): string {
  return svgContent.replace('<svg', `<svg fill="${color}"`);
}
</script>
<style scoped lang="scss"></style>
